import { render, staticRenderFns } from "./cardItemByTeacherList.vue?vue&type=template&id=d4337512&"
import script from "./cardItemByTeacherList.vue?vue&type=script&lang=js&"
export * from "./cardItemByTeacherList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/card/cardItemByTeacherList.vue"
export default component.exports